import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseResponse } from "app/business/common/baseresponse";
import { LookUpItem } from "app/business/common/lookupitem";
import { tblBankDetail } from "app/models/user/tblbankdetail";
import { tblUserMaster } from "app/models/user/tblusermaster";
import { use } from "echarts";
import { environment } from "environments/environment";

@Injectable({
    providedIn: "root",
})
export class UserService {
    constructor(private http: HttpClient) { }

    async getUsers(input: any): Promise<BaseResponse> {
        return await this.http.post(environment.apiUrl + `/User/GetUsers`, input)
            .toPromise() as BaseResponse;
    }

    async addUser(user: tblUserMaster): Promise<BaseResponse> {
        return await this.http.post(environment.apiUrl + `/User/AddUser`, user)
            .toPromise() as BaseResponse;
    }

    async updateUser(user: tblUserMaster): Promise<BaseResponse> {
        return await this.http.post(environment.apiUrl + `/User/UpdateUser`, user)
            .toPromise() as BaseResponse;
    }

    async deleteUser(userId: string): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/User/DeleteUser/' + userId)
            .toPromise() as BaseResponse;
    }

    async checkMobileExistInUser(lookup: LookUpItem): Promise<BaseResponse> {
        return await this.http.post(environment.apiUrl + `/User/CheckMobileExistInUser`, lookup)
            .toPromise() as BaseResponse;
    }

    async checkEmailExistInUser(lookup: LookUpItem): Promise<BaseResponse> {
        return await this.http.post(environment.apiUrl + `/User/CheckEmailExistInUser`, lookup)
            .toPromise() as BaseResponse;
    }

    async getUserById(userId: string): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/User/GetUserById/' + userId)
            .toPromise() as BaseResponse;
    }

    async saveBasicInformation(user: tblUserMaster): Promise<BaseResponse> {
        return await this.http.post(environment.apiUrl + `/User/SaveBasicInformation`, user)
            .toPromise() as BaseResponse;
    }

    async getUserDocument(userId: string): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/User/GetUserDocument/' + userId)
            .toPromise() as BaseResponse;
    }

    async saveDocument(userId: string, files?: { files }): Promise<BaseResponse> {
        var fd = new FormData();
        fd.append("data", JSON.stringify(userId));

        if (files && files.files && files.files.length > 0) {
            for (let i = 0; i < files.files.length; i++) {
                fd.append("files", files.files[i]);
            }
        }

        return await this.http.post(environment.apiUrl + '/User/SaveDocument', fd)
            .toPromise() as BaseResponse;
    }

    async getUserBankDetail(userId: string): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/User/GetUserBankDetail/' + userId)
            .toPromise() as BaseResponse;
    }

    async saveBankDetail(bankDetail: tblBankDetail, file: { file: File }): Promise<BaseResponse> {
        var fd = new FormData();
        fd.append("data", JSON.stringify(bankDetail));

        if (file) {
            fd.append("file", file.file);
        }

        return await this.http.post(environment.apiUrl + '/User/SaveBankDetail', fd)
            .toPromise() as BaseResponse;
    }

    async updateCurrentRoleId(userId: string, roleId: number): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/User/UpdateCurrentRoleId/' + userId + '/' + roleId)
            .toPromise() as BaseResponse;
    }

    async changeUserActivationStatus(userId: string): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/User/ChangeUserActivationStatus/' + userId)
            .toPromise() as BaseResponse;
    }

    async updateUserStatus(userId: string, status: number): Promise<BaseResponse> {
        return await this.http.get(environment.apiUrl + '/User/UpdateUserStatus/' + userId + '/' + status)
            .toPromise() as BaseResponse;
    }


}
